export default __webpack_public_path__ + "static/media/bird-jay.1860f7c3.svg";